import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { fadeUp, viewport } from "@/lib/motion";
import { Wrench, Car, KeyRound, Lock, Droplets, Home, Zap, Truck, ShieldCheck } from "lucide-react";
import { useSiteConfig } from "@/context/SiteConfigContext";

const ICONS = { "roadside assistance": Truck, "towing": Truck, "flat tire help": Car, "jump starts": Zap, "vehicle lockouts": KeyRound, "locksmiths": ShieldCheck, "home lockouts": Lock, "plumbing": Droplets, "leaks": Droplets, "emergency home services": Home };
const iconFor = (label) => ICONS[label.toLowerCase()] || Wrench;

export default function Services() {
  const { config } = useSiteConfig();
  const t = config.t.services;
  return (
    <section id="services" className="bg-[#FAFAFC] py-28 sm:py-36" data-testid="services-section">
      <div className="mx-auto max-w-6xl px-6">
        <Reveal>
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-brand">{t.eyebrow}</p>
          <h2 className="mt-4 max-w-3xl text-4xl font-bold tracking-tighter text-neutral-900 sm:text-5xl lg:text-6xl">
            {t.heading}
          </h2>
        </Reveal>

        <motion.div variants={{ show: { transition: { staggerChildren: 0.05 } } }} initial="hidden" whileInView="show" viewport={viewport}
          className="mt-14 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
          {config.lists.services.map((label) => {
            const Icon = iconFor(label);
            return (
              <motion.button key={label} variants={fadeUp}
                whileHover={{ y: -6 }} whileTap={{ scale: 0.97 }}
                className="group flex flex-col items-start gap-6 rounded-3xl border border-black/5 bg-white p-6 text-left shadow-sm"
                data-testid={`service-tile-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                <div className="grid h-12 w-12 place-items-center rounded-2xl bg-brand/5 text-brand transition-colors group-hover:bg-brand group-hover:text-white">
                  <Icon className="h-6 w-6" />
                </div>
                <span className="text-[15px] font-semibold leading-tight text-neutral-800">{label}</span>
              </motion.button>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
